import {call, put, take, takeLatest} from 'redux-saga/effects'

import history from '../../history'

import * as addToLookActions from '../../actions/addToLook'
import * as modalActions from '../../actions/modal'
import * as track from '../../track/lookbuilder'
import * as URLS from '../../urls'

/**
 * Handles adding products to look for Lookbuilder origins
 *
 * @param {Object} action
 * @param {Object} action.payload
 * @param {Array} action.payload.products An array of product objects
 */
export function* addLookbuilderProductsToLookWorker({payload: {products}}) {
  const thunk = yield call(addToLookActions.addToNewLook, products, 'lookbuilder')
  yield put(thunk)
  yield take(addToLookActions.ADD_TO_LOOK_SUCCESS)
  yield call(track.createdLookbuilderLook)
  yield put(modalActions.closeSlidingModal())
  yield call(history.push, URLS.LOOKBUILDER_SUCCESS)
  yield put(addToLookActions.addToLookIdle())
}

export function* addLookbuilderProductsToLookSaga() {
  yield takeLatest(
    addToLookActions.ADD_LOOKBUILDER_PRODUCTS_TO_LOOK,
    addLookbuilderProductsToLookWorker,
  )
}
